import { Dispatch } from "react";
import { generalShowLoader, generalOpenModalError, generalOpenModalMessage } from "../../general.actions";
import { KEYS } from "../../../constants/keysStorage";
import * as http from "../../../api/http";
import { ENDPOINTS } from "../../../api/config";
import { GESTION_PRODUCTOS_TYPES } from "../../../constants/gestionProducto.types";
import { State } from "../../../reducers";

const PRODUCTOS_FILE = process.env.REACT_APP_PRODUCTOS_FILE;

export const setFormProductos = (form: any) => ({ type: GESTION_PRODUCTOS_TYPES.PRODUCTOS_CHANGE_FORM_CARGA, payload: form })
export const setDataProductos = (data: any) => ({ type: GESTION_PRODUCTOS_TYPES.PRODUCTOS_SET_DATA_PRODUCTO, payload: data })
export const setProductosActivo = (data: any) => ({ type: GESTION_PRODUCTOS_TYPES.PRODUCTOS_SET_PRODUCTO_ACTIVO, payload: data })
export const setDataFileProductos = (dataFile: any) => ({ type: GESTION_PRODUCTOS_TYPES.PRODUCTOS_SET_FILE_DATA_CARGADA, payload: dataFile })
export const clearProductoModule = () => ({ type: GESTION_PRODUCTOS_TYPES.PRODUCTOS_CLEAR, payload: {} })

export const getProductos = () => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true));
    const formConsulta = {
        tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
    }
    await http
        //.post(ENDPOINTS.PRODUCTOS_GET_GENERADOS, formConsulta, {}, KEYS.TOKEN)
        .post(ENDPOINTS.LIBRO_COMPRAS_GET_GENERADOS, formConsulta, {}, KEYS.TOKEN)
        .then(async (res: any) => {
            const dataProductos = res?.body?.length > 0 ? res.body : [];
            dispatch(setDataProductos(dataProductos));
        })
        .catch((err) => {
            const messageErr = 'No se logró obtener los datos de los productos';
            dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
        })
        .finally(() => dispatch(generalShowLoader(false)))
}

export const postCargarProductos = (form: any, base64Str: string) => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true));
    const formConsulta = {
  base64File: base64Str,
  typeFile: form.ext.replace('.', '').toLowerCase(),
  itemsFile: form.datosHacienda ?? [],
  varianteArchivoProducto: false,
  tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
};

    try {
        const res = await http.post(ENDPOINTS.GESTION_PRODUCTO_CARGAR_NUEVO, formConsulta, {}, KEYS.TOKEN);
        // No abrir modal aquí
        return true;
    } catch (err: any) {
    const messageErr = 'No se logró cargar los productos, intente nuevamente.';
    dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status));
    return false;
}
finally {
        dispatch(generalShowLoader(false));
    }
};


export const getProductosDetallado = (idProducto: number, exportar:boolean = false, productoActivo:any) => async (dispatch: Dispatch<any>) => {
    dispatch(generalShowLoader(true));
    const formConsulta = {
        tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
    }
    return await http
        //.post(ENDPOINTS.PRODUCTOS_GET_DETALLADO, formConsulta, {}, KEYS.TOKEN)
        .post(ENDPOINTS.LIBRO_COMPRAS_GET_DETALLADO, formConsulta, {}, KEYS.TOKEN)
        .then(async (res: any) => {
            dispatch(setProductosActivo(res?.body ?? {}));

            if(exportar){
                const itemExcel = res?.body[0];
                const decodedData = atob(itemExcel?.Excel);
                const byteArray = new Uint8Array(decodedData.length);
                for (let i = 0; i < decodedData.length; i++){
                    byteArray[i] = decodedData.charCodeAt(i);
                }
                const blob = new Blob([byteArray], { type: 'application/vnd.ms-excel' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${PRODUCTOS_FILE}`;
                // Simular un clic en el enlace de descarga
                document.body.appendChild(a);
                a.click();
                // Limpiar el enlace y el objeto URL
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }
            return true;
        })
        .catch((err) => {
            const messageErr = 'No se logró exportar los productos, intente nuevamente.';
            dispatch(generalOpenModalError(err?.response?.data?.message ?? messageErr, err?.response?.data?.status))
            return false;
        })
        .finally(() => dispatch(generalShowLoader(false)))
}